<template>
  <div ref="chartRef" :class="className" :style="echartsStyle" />
</template>
<script lang="ts" setup>
import * as echarts from "echarts";
import { computed, defineProps, markRaw, nextTick, onMounted, onUnmounted, ref, watch } from "vue";

const myChart = ref();
const resizeEle = ref();
const drawTiming = ref();
const chartRef = ref();

const props = defineProps({
  option: {
    type: Object,
    default: () => ({}),
    required: true
  },
  trendsTooltip: {
    type: Boolean,
    default: false
  },

  className: {
    type: String,
    default: "chart"
  },
  width: {
    type: String,
    default: ""
  },
  height: {
    type: String,
    default: ""
  }
});

// 计算响应式样式
const echartsStyle = computed(() => ({
  width: props.width ? `${props.width}px` : "100%",
  height: props.height ? `${props.height}px` : "100%"
}));

const resize = () => {
  clearTimeout(drawTiming.value);
  drawTiming.value = setTimeout(() => {
    let { clientWidth: width, clientHeight: height } = chartRef.value.parentElement;
    myChart.value.resize({ width, height });
  }, 200);
};
const emit = defineEmits(["load"]);
const initChart = () => {
  // 初始化echart
  myChart.value = markRaw(echarts.init(chartRef.value as HTMLDivElement));
  emit("load", myChart.value);
  // 设置true清空echart缓存
  myChart.value.setOption(props.option, { notMerge: true });
};

// 页面挂载，开始绘制图表
onMounted(() => {
  nextTick(() => {
    initChart();
    resizeEle.value = new ResizeObserver(entries => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        myChart.value.resize({ width, height });
      }
    });

    // 传入需要监听的DOM元素
    resizeEle.value.observe(chartRef.value);
    window.addEventListener("resize", resize);
  });
});

// 页面卸载，销毁事件和实例
onUnmounted(() => {
  // 取消对所有节点的监听
  resizeEle.value.disconnect(chartRef.value);
  window.removeEventListener("resize", resize);

  myChart.value.dispose();
  myChart.value = null;
  clearTimeout(drawTiming.value);
  drawTiming.value = null;
});

// 更新图表配置
const updateChart = () => {
  if (myChart.value) {
    myChart.value.setOption(props.option, { notMerge: true }); // 避免覆盖前一个option
  }
};

// 监听图表数据时候变化，重新渲染图表
watch(
  () => props.option,
  () => {
    nextTick(() => {
      updateChart();
    });
    // }
  },
  { deep: true }
);
defineExpose({
  updateChart
});
</script>
